import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Get the main platform URL based on environment
const getMainPlatformUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  return 'https://ai.app.platform.halisoft.biz';
};

/**
 * Register - Redirects to the main platform's unified signup page
 * The main platform handles registration and redirects back with token
 */
const Register = () => {
  const mainPlatformUrl = getMainPlatformUrl();
  const [searchParams] = useSearchParams();
  const selectedPlan = searchParams.get('plan') || 'free';

  useEffect(() => {
    // Get the return URL (where to redirect after signup)
    const redirect = searchParams.get('redirect') || '/dashboard';

    // Build the customer portal return URL with plan info
    let returnUrl = `${window.location.origin}${redirect}`;
    if (selectedPlan !== 'free') {
      returnUrl = `${window.location.origin}/subscription?plan=${selectedPlan}`;
    }

    // Redirect to main platform signup with HaliLab branding
    // mode=signup opens the Sign Up tab directly
    const signupUrl = `${mainPlatformUrl}/halilab/login?mode=signup&returnUrl=${encodeURIComponent(returnUrl)}`;

    window.location.href = signupUrl;
  }, [mainPlatformUrl, searchParams, selectedPlan]);

  // Show loading while redirecting
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a1628 0%, #0f2847 40%, #0a1628 100%)',
      color: 'white',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '24px', marginBottom: '16px' }}>
          Hali<span style={{ color: '#8b5cf6' }}>Lab</span>
        </div>
        <div style={{ color: 'rgba(255,255,255,0.6)' }}>
          Redirecting to sign up...
        </div>
      </div>
    </div>
  );
};

export default Register;
